export enum DeclarationStatusEnum {

    WAITING_VALIDATION = 1,
    VALIDATED = 2,
    DENIED = 3

}
